import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    showModal: false,
    user: {},
    token: null,
    haveNotification: false
  },
  mutations: {
    toggleModal(state) {
      if (state.showModal) {
        state.showModal = false;
      } else {
        state.showModal = true;
      }
    },

    setToken(state, token) {
      state.token = token;
    },

    setUser(state, user) {
      state.user = user;
    }


  },
  getters: {
    modalState: state => state.showModal,
    user: state => state.user
  },
  actions: {

  },
  modules: {
  }
})
